var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWeightagePurple(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1681 9.30469L12.2617 15.459C12.2739 15.5314 12.2638 15.6059 12.2325 15.6725C12.2013 15.739 12.1505 15.7944 12.0869 15.8313C12.0234 15.8682 11.9501 15.8848 11.8768 15.8789C11.8035 15.873 11.7338 15.8448 11.677 15.7982L9.09286 13.8587C8.96811 13.7655 8.81657 13.7151 8.66085 13.7151C8.50513 13.7151 8.35358 13.7655 8.22883 13.8587L5.64037 15.7975C5.58357 15.844 5.51395 15.8721 5.44078 15.878C5.36761 15.8839 5.29438 15.8674 5.23085 15.8306C5.16732 15.7938 5.11652 15.7386 5.08522 15.6722C5.05393 15.6058 5.04362 15.5314 5.05569 15.459L6.14853 9.30469",
    stroke: "#4F4F4F",
    strokeWidth: 1.44365,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.65908 10.1053C11.051 10.1053 12.99 8.16623 12.99 5.77431C12.99 3.38239 11.051 1.44336 8.65908 1.44336C6.26716 1.44336 4.32812 3.38239 4.32812 5.77431C4.32812 8.16623 6.26716 10.1053 8.65908 10.1053Z",
    stroke: "#4F4F4F",
    strokeWidth: 1.44365,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeightagePurple);
export default __webpack_public_path__ + "static/media/weightage_purple.76cb0a3417a16aece65791f2c12fd92e.svg";
export { ForwardRef as ReactComponent };